export class AdminLogin {
  ID: number;
  EMAIL: string;
  PASSWORD: string;
}
